import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Identity18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9 6.25C7.50217 6.25 6.25 7.50217 6.25 9C6.25 9.88719 6.69442 10.7409 7.41884 11.25C6.51567 11.25 5.56281 11.4018 4.93446 12.1158C4.23197 12.9141 4.25 14 4.25 15H5.75C5.75 14.3985 5.63662 13.5884 6.06054 13.1067C6.21476 12.9315 6.532 12.75 7.3 12.75H10.6911C11.4641 12.769 11.7861 12.9496 11.9425 13.1252C12.3649 13.5993 12.25 14.4054 12.25 15H13.75C13.75 14.0028 13.7687 12.92 13.0625 12.1273C12.4394 11.428 11.4771 11.25 10.5812 11.25C11.3056 10.7409 11.75 9.88719 11.75 9C11.75 7.50217 10.4978 6.25 9 6.25ZM9 7.75C9.68083 7.75 10.25 8.31917 10.25 9C10.25 9.68083 9.68083 10.25 9 10.25C8.31917 10.25 7.75 9.68083 7.75 9C7.75 8.31917 8.31917 7.75 9 7.75Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5.275 1.25H2.5C1.7859 1.25 1.25 1.88679 1.25 2.57692V16.4231C1.25 17.1132 1.7859 17.75 2.5 17.75H15.5C16.2141 17.75 16.75 17.1132 16.75 16.4231V2.57692C16.75 1.88679 16.2141 1.25 15.5 1.25H12.725C12.6092 0.67944 12.1047 0.25 11.5 0.25H6.5C5.89526 0.25 5.39082 0.67944 5.275 1.25ZM6.75 3.25V1.75H11.25V3.25H6.75ZM12.75 2.75V3.5C12.75 4.19036 12.1904 4.75 11.5 4.75H6.5C5.80964 4.75 5.25 4.19036 5.25 3.5V2.75H2.75V16.25H15.25V2.75H12.75Z'
      fill='currentColor'
    />
  </Svg>
);

Identity18.displayName = 'Identity18';
export default Identity18;
